var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('canvas',{staticStyle:{"display":"none","background-color":"#fff"},attrs:{"id":"myCanvas"}})])
}]

export { render, staticRenderFns }